import { render, staticRenderFns } from "./workday-shift-assign.vue?vue&type=template&id=1696bb9d&"
import script from "./workday-shift-assign.vue?vue&type=script&lang=js&"
export * from "./workday-shift-assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "workday-shift-assign.vue"
export default component.exports